import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import AlbumSlideshowGridViewerActionButton from '../../../../components/grid/components/AlbumSlideshowGridViewer/components/AlbumSlideshowGridViewerActionButton';
import ShareIcon from '../../../../components/icons/ShareIcon';
import EditIcon from '../../../../components/icons/EditIcon';
import Button from '../../../../components/global/Button';
import FullScreenIcon from '../../../../components/icons/FullScreenIcon';
import AddPhotoIcon from '../../../../components/icons/AddPhotoIcon';
import TrashIcon from '../../../../components/icons/TrashIcon';

const propTypes = {
  authenticated: PropTypes.bool,
  isOwner: PropTypes.bool,
  isContributor: PropTypes.bool,
  onEdit: PropTypes.func,
  onShare: PropTypes.func,
  onDelete: PropTypes.func,
  onPublishToggle: PropTypes.func,
  onFullScreenToggle: PropTypes.func,
  isPublished: PropTypes.bool,
  onAddPhotos: PropTypes.func,
};

const AlbumSlideshowViewerActions = ({
  authenticated,
  isOwner,
  isContributor,
  onEdit,
  onShare,
  onDelete,
  onPublishToggle,
  onFullScreenToggle,
  isPublished,
  onAddPhotos,
}) => {
  if (!authenticated || !isOwner || isContributor) {
    return (
      <Fragment>
        {onShare && (
          <AlbumSlideshowGridViewerActionButton
            tooltipId="slideshow-share"
            label="Share"
            icon={<ShareIcon />}
            onClick={onShare}
          />
        )}
        {onFullScreenToggle && (
          <AlbumSlideshowGridViewerActionButton
            tooltipId="slideshow-toggle"
            label="Toggle Full Screen"
            icon={<FullScreenIcon />}
            onClick={onFullScreenToggle}
          />
        )}
        {onAddPhotos && (
          <AlbumSlideshowGridViewerActionButton
            tooltipId="add-photos-slideshow"
            label="Add Photos"
            className="d-flex"
            icon={<AddPhotoIcon />}
            onClick={onAddPhotos}
          />
        )}
      </Fragment>
    );
  }

  return (
    <Fragment>
      {onEdit && (
        <AlbumSlideshowGridViewerActionButton
          tooltipId="slideshow-edit"
          label="Edit"
          className="d-flex"
          icon={<EditIcon />}
          onClick={onEdit}
        />
      )}
      {onShare && (
        <AlbumSlideshowGridViewerActionButton
          tooltipId="slideshow-share"
          label="Share"
          className="d-flex"
          icon={<ShareIcon />}
          onClick={onShare}
        />
      )}
      {onFullScreenToggle && (
        <AlbumSlideshowGridViewerActionButton
          tooltipId="slideshow-toggle"
          label="Toggle Full Screen"
          icon={<FullScreenIcon />}
          onClick={onFullScreenToggle}
        />
      )}
      {onDelete && (
        <AlbumSlideshowGridViewerActionButton
          tooltipId="delete-slideshow"
          label="Delete"
          className="d-flex"
          icon={<TrashIcon />}
          onClick={onDelete}
        />
      )}
      {onAddPhotos && (
        <AlbumSlideshowGridViewerActionButton
          tooltipId="add-photos-slideshow"
          label="Add Photos"
          className="d-flex"
          icon={<AddPhotoIcon />}
          onClick={onAddPhotos}
        />
      )}
      {onPublishToggle && (
        <Button
          btnSize="sm"
          btnOutline={isPublished}
          btnStyle={isPublished ? 'danger' : 'primary'}
          onClick={onPublishToggle}
        >
          {isPublished ? 'Unpublish' : 'Publish'}
        </Button>
      )}
    </Fragment>
  );
};

AlbumSlideshowViewerActions.propTypes = propTypes;

export default AlbumSlideshowViewerActions;
